<template>
  <section v-if="isReady" class="lock">
    <ms-loading :size="'large'" :justify="true" />
  </section>
  <section v-else>isready false</section>
</template>

<script>
import Loading from './../ms/Loading';

export default {
  components: {
    'ms-loading': Loading
  },
  data() {
    return {
      isReady: false
    };
  },
  mounted() {
    this.$nextTick(() => (this.isReady = true));
  }
};
</script>

<style lang="scss" scoped>
.lock {
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0;
  left: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  background: rgba(255, 255, 255, 0.5);
  z-index: 10;
}
</style>
